export default __webpack_public_path__ + "static/media/1.641f949a.png";